import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GroupService } from 'src/app/services/group.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-group-add',
  templateUrl: './group-add.component.html',
  styleUrls: ['./group-add.component.css']
})
export class GroupAddComponent implements OnInit {
  group: any = {}
  errorMsg: string;
  constructor(
    private router: Router,
    private groupService: GroupService
  ) { }

  ngOnInit() { }

  create() {
    this.groupService.add(this.group)
      .then((res) => {
        $('#btnClose').click();
        this.router.navigate([`g/${res.key}`]);
      }, err => {
        this.errorMsg = err.Message;
      });
  }

}
